// export const Baseurl = "http://localhost:4031";
export const Baseurl = "https://instavaluermainapi.instavaluer.com";
export const Imageurl = "https://instavaluerimageapi.instavaluer.com";